import { render } from "./CartCountBadge.vue?vue&type=template&id=01aeaf44"
import script from "./CartCountBadge.vue?vue&type=script&lang=js"
export * from "./CartCountBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__